import { render } from "./AlarmButtonEditCard.vue?vue&type=template&id=23f500ec"
import script from "./AlarmButtonEditCard.vue?vue&type=script&lang=js"
export * from "./AlarmButtonEditCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__